module.exports = __webpack_public_path__ + "static/media/sawat-lk.332b043e.png";